import { IMediaAssetMap } from "constants/media-asset";
import _ from "lodash";

export const createEmptyMedia = () => ({
    asset_id: "",
    image_id: "",
    type: "",
    filename: "",
    source: "",
    emptyMedia: true,
});

export const getSortedMediaKeys = (mediaMap: IMediaAssetMap = {}) =>
    _.keys(mediaMap)
        .map((key) => _.parseInt(key, 10))
        .sort((a, b) => a - b);

export const createNewMediaKey = (mediaMap: IMediaAssetMap = {}) => {
    const lastMediaKey = _.last(getSortedMediaKeys(mediaMap)) || 0;
    return _.toString(lastMediaKey + 1);
};

export const transformMediaMap = (mediaMap: IMediaAssetMap): IMediaAssetMap => {
    const lastKey = getSortedMediaKeys(mediaMap).pop();
    const rangedKeys = _.isNumber(lastKey) ? _.range(1, lastKey + 1) : [];
    return _.reduce(
        rangedKeys,
        (result, key) => {
            result[`${key}`] = mediaMap[`${key}`] || createEmptyMedia();
            return result;
        },
        {},
    );
};
